import { MenuItem, SectionLabel } from './app.interface';

export function menuItemSections(
  item: Pick<MenuItem, 'section' | 'sections'>
): string[] {
  const values = Array.isArray(item.sections) && item.sections.length > 0
    ? item.sections
    : [item.section];
  return [...new Set(values.map((value) => value.trim()).filter(Boolean))];
}

export function mergeSectionLabels(
  configured: SectionLabel[],
  items: MenuItem[]
): SectionLabel[] {
  const labels = configured.filter(
    (section) => section.name.trim() && section.value.trim()
  );
  const existingValues = new Set(labels.map((section) => section.value));
  const inferred = items.reduce<SectionLabel[]>((sections, item) => {
    menuItemSections(item).forEach((section) => {
      if (!existingValues.has(section)) {
        existingValues.add(section);
        sections.push({ name: section, value: section });
      }
    });
    return sections;
  }, []);
  return [...labels, ...inferred];
}
